// extracted by mini-css-extract-plugin
module.exports = {"toggle-group__panel--active":"toggle-group_toggle-group__panel--active__dvkJO","toggle-group__panel--hidden":"toggle-group_toggle-group__panel--hidden__UHvSK"};